import { render, staticRenderFns } from "./EntornoCondominio.vue?vue&type=template&id=5721fb36"
import script from "./EntornoCondominio.vue?vue&type=script&lang=js"
export * from "./EntornoCondominio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports